import styles from './PulsatingCircle.module.css';
import React, { CSSProperties } from 'react';
import cn from 'classnames';
import { colorText } from '../../../constants/constants.style';

type PulsatingCircleProps = {
    className?: string;
    circleColor?: string;
};

export function PulsatingCircle({ className, circleColor }: PulsatingCircleProps) {
    return (
        <div className={cn(styles.pulsatingCircle, className)}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 80 80"
                fill="none"
                style={{ color: circleColor || colorText }}
            >
                <circle cx="40" cy="40" r="38" strokeWidth="4" fill={'none'} />
            </svg>
        </div>
    );
}
